<template>
    <span>
        <select class="input_s" v-model="selectedHour" :disabled="disabled" @change="updateValue">
            <option v-for="t in hours" :key="t" :value="t">{{ t }} 시</option>
        </select>
        <select class="input_s" v-model="selectedMin" :disabled="disabled" @change="updateValue">
            <option hidden :value="initMin">{{ initMin }} 분</option>
            <option v-for="t in mins" :key="t" :value="t">{{ t }} 분</option>
        </select>
    </span>
</template>

<script>
const moment = require('@/util/MPMoment')
export default {
    props: {
        value: String,
        disabled: Boolean,
        minuteInterval: Number,
        timeMin: Object,
        timeMax: Object
    },
    data() {
        return {
            hours: [],
            mins: [],

            selectedMoment: undefined,
            selectedHour: '09',
            selectedMin: '00',
            initMin: '00'
        }
    },
    watch: {
        timeMax: function () {
            this.initVariables()
        },
        value: {
            immediate: true,
            deep: true,
            handler: function (newValue) {
                this.selectedMoment = moment(newValue)
                this.initVariables()
            }
        }
    },
    mounted() {
        this.initVariables()
    },
    methods: {
        initVariables() {
            this.hours = []
            let startHour = 0
            if (this.timeMin != undefined) {
                startHour = this.timeMin.hours()
            }
            let endHour = 24
            if (this.timeMax != undefined) {
                endHour = this.timeMax.hours()
            }
            for (let i = startHour; i <= endHour; i++) {
                let h = ('0' + i).slice(-2)
                this.hours.push(h)
            }
            this.mins = []
            for (let i = 0; i < 60; i += 5) {
                let m = ('0' + i).slice(-2)
                this.mins.push(m)
            }
            if (this.value == undefined) {
                return
            }
            this.selectedMoment = moment(this.value)
            let h = String(this.selectedMoment.hour())
            this.selectedHour = ('0' + h).slice(-2)
            let m = this.selectedMoment.minute()
            this.selectedMin = ('0' + m).slice(-2)
            this.initMin = this.selectedMin
            this.$forceUpdate()
        },

        updateValue() {
            const hour = Number(this.selectedHour)
            const minute = Number(this.selectedMin)
            const date = moment(this.value).set('hours', hour).set('minutes', minute)

            let string = date.toString()
            this.$emit('input', string)
        }
    }
}
</script>
